import React from 'react';
import { Skeleton, Stack } from '@rossum/ui/material';
import { DrawerConfig } from '../../../../containers/DocumentValidation/ValidationEmailDrawer';
import { Annotation } from '../../../../types/annotation';
import { SidebarActionBar } from '../../../document-sidebar';
import { ConfirmButton } from './sidebar-footer-actions/ConfirmButton';
import { SidebarFooterActions } from './sidebar-footer-actions/SidebarFooterActions';

type SidebarFooterProps = {
  annotation: Annotation | undefined;
  onEmailThreadOpen: (drawerConfig?: DrawerConfig) => void;
  loading?: boolean;
  onNavigate: (id: number | 'all') => void;
};

const SidebarFooter = React.memo(
  ({
    annotation,
    onEmailThreadOpen,
    onNavigate,
    loading = false,
  }: SidebarFooterProps) => {
    return (
      <Stack
        direction="row"
        spacing={1}
        sx={{
          py: 1,
          px: 1,
          width: '100%',
          borderTop: '1px solid',
          borderColor: theme => theme.palette.divider,
          backgroundColor: theme => theme.palette.background.paper,
        }}
      >
        {loading || !annotation ? (
          <SidebarActionBar actions={[]} loading>
            <Skeleton sx={{ height: 50, width: '100%' }} />
          </SidebarActionBar>
        ) : (
          <SidebarFooterActions
            annotation={annotation}
            onEmailThreadOpen={onEmailThreadOpen}
          >
            <ConfirmButton annotation={annotation} onNavigate={onNavigate} />
          </SidebarFooterActions>
        )}
      </Stack>
    );
  }
);

SidebarFooter.displayName = 'SidebarFooter';

export { SidebarFooter };
